<template>
  <ul class="c-course-list">
    <li
      class="c-course-item"
      :class="item.active?'is-active':''"
      v-for="item in data"
      :key="item.id"
      @click.self="onItemClick(item)"
    >
      <p @click.self="onItemClick(item)">{{item.chapter_name}}</p>
      <ul v-show="item.active">
        <li
          v-for="sub in item.lesson_list"
          class="c-course-subtitle"
          :key="sub.id"
          :class="value.lessonId===sub.id?'is-active':''"
          @click.stop="onSubClick(sub, item)"
        >
          {{sub.lesson_name}}
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { CACHED_LO, CRM_USER } from '@/config/storage';
// 最多保留100调记录
const MAX_CACHE = 100;
export default {
  name: 'ChapterList',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    course: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onItemClick(item) {
      this.$emit('toggle', item);
    },
    onSubClick(item, chapter) {
      const lo = {
        ...this.value,
        lessonId: item.id,
        chapterId: chapter.id,
        lessonName: item.lesson_name,
      };
      this.$emit('input', lo);
      const user = JSON.parse(localStorage.getItem(CRM_USER)) || {};
      const key = CACHED_LO + user.id;
      const cachedCourseList = JSON.parse(localStorage.getItem(key)) || [];
      if (cachedCourseList.length >= MAX_CACHE) {
        cachedCourseList.length = MAX_CACHE;
      }
      localStorage.setItem(key, JSON.stringify([lo, ...cachedCourseList]));
    },
  },
};
</script>

<style lang="scss" scoped>
.c-course-list {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
}
.c-course-item {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  padding-left: 18px;
  background-position: top 5px left;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  background-image: url('~@/views/pt/images/plus.png');
  & + .c-course-item {
    margin-top: 10px;
  }
  &.is-active {
    background-image: url('~@/views/pt/images/minus.png');
  }
  p {
    font-weight: bolder;
  }
  ul {
    margin-top: 18px;
  }
}
.c-course-subtitle {
  color: rgba(96, 98, 102, 1);
  font-size: 15px;
  margin: 13px 0;
  position: relative;
  background-position: top 3px left;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  background-image: url('~@/views/pt/images/minus_2.png');
  padding-left: 16px;
  &.is-active {
    color: rgba(25, 137, 250, 1);
  }
  &::before {
    content: '';
    height: 100%;
    width: 1px;
    border-left: 1px dashed rgba(196, 200, 210, 1);
    left: 5px;
    top: 14px;
    position: absolute;
  }
  &:last-of-type::before {
    display: none;
  }
}
</style>
